import { render, staticRenderFns } from "./record_details.vue?vue&type=template&id=f44d10ce&scoped=true&"
import script from "./record_details.vue?vue&type=script&lang=js&"
export * from "./record_details.vue?vue&type=script&lang=js&"
import style0 from "./record_details.vue?vue&type=style&index=0&id=f44d10ce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44d10ce",
  null
  
)

export default component.exports